export const en = {
  projectSummaryEmail: 'Project Summary Email',
  taskDoneEmail: 'Task Done Email',
  save: 'Save',
  guestNotifications: 'Client Notifications',
  guestCollaboration: 'Client Collaboration',
  allowGuestSeeGuestsFeedback:
    'Allow Clients to see tasks created by other clients',
  allowGuestChangeTaskStatus: 'Allow Clients to change the status of a task',
  onlyAvailableOnPremium: 'Available on a higher plan',
  upgradeNow: 'Upgrade now',
  guestAccessWarning: 'To access these preferences, you must ',
  allowGuestsViewCommitContent:
    'Allow Clients to view git commit content from task comments',
  allowGuestsAssignedToTasks: 'Allow Clients to be assigned to tasks',
  feedbackCollection: 'Feedback collection',
  sendFeedbackTo: 'Send new client feedback to',
  staysInFeedback:
    'New client feedback stays in the Feedback tab until someone moves it.',
  skipsFeedbackTab: (columnName: string) =>
    `New client feedback skips the Feedback tab and is added to ${columnName}.`,
  skipsToLastColumn: (columnName: string) =>
    `New client feedback skips the Feedback tab and is added to ${columnName}, past the rest of the board.`
};

export type Translations = typeof en;
